<template>
  <div class="import-xls-files__table">
    <table class="mds-data-table bordered" boder="1">
      <thead class="mds-data-table__header">
        <tr class="mds-data-table__row">
          <th
            v-for="(header, index) in headers"
            class="mds-data-table__header-cell"
            :key="`import-table-header-${header.text}-${index}`"
            :class="header.class || ''"
            :width="header.width || '*'"
            :style="headers.style || {}"
          >
            {{ header.text }}
          </th>
        </tr>
      </thead>
      <tbody class="mds-data-table__body">
        <tr
          v-for="(row, index) in body"
          class="mds-data-table__row"
          :key="`import-table-body-row-${index}`"
          :class="row.class || ''"
          :width="row.width || ''"
          :style="row.style || {}"
        >
          <td
            v-for="(column, index) in row.data"
            class="mds-data-table__cell"
            :key="`import-table-column-${column.text}-${index}`"
            :class="column.class || ''"
            :width="column.width || ''"
            :style="column.style || {}"
          >
            {{ column.text }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="table-caption">
      <slot name="caption">
        <p>
          <strong>NOTE:</strong>
          <br />
          The Menu Display Name column and Preferred column must be present in the file, but having
          data in the columns is optional.
        </p>
        <p>
          If the lineup already exists in our system, we will replace it with whatever you import.
        </p>
      </slot>
    </div>
  </div>
</template>
<script>
import { every, get } from 'lodash';

export default {
  name: 'import-format-table',
  data() {
    return {};
  },
  props: {
    headers: {
      type: Array,
      required: true,
      validator: (headers) => every(headers, (header) => get(header, 'text')),
    },
    body: {
      type: Array,
      required: true,
      validator: (rows) => every(
        rows,
        (row) => get(row, 'data')
            && Array.isArray(row.data)
            && every(row.data, (data) => get(data, 'text')),
      ),
    },
  },
};
</script>
<style lang="scss">
.import-xls-files__table {
  p {
    @include mds-body-text-m();
  }
  .table-caption {
    min-height: 40px;
  }
  .mds-data-table {
    border-radius: $mds-border-radius-panel;
    &.bordered {
      border: 1px solid $mds-color-neutral-80;
      border-radius: $mds-border-radius-panel;
      -moz-border-radius: $mds-border-radius-panel;
      -webkit-border-radius: $mds-border-radius-panel;
      border-collapse: initial;

      th,
      td {
        border-left: 1px solid $mds-color-neutral-80;
        border-top: 1px solid $mds-color-neutral-80;
      }

      td {
        color: $mds-color-neutral-37;
      }

      th:first-child {
        border-radius: $mds-border-radius-panel-top-right;
        -moz-border-radius: $mds-border-radius-panel-top-right;
        -webkit-border-radius: $mds-border-radius-panel-top-right;
      }

      th:last-child {
        border-radius: $mds-border-radius-panel-bottom-right;
        -moz-border-radius: $mds-border-radius-panel-bottom-right;
        -webkit-border-radius: $mds-border-radius-panel-bottom-right;
      }

      td:first-child,
      th:first-child {
        border-left: medium none;
      }

      tr:last-child td:first-child {
        border-bottom-left-radius: $mds-border-radius-panel;
        -moz-border-bottom-left-radius: $mds-border-radius-panel;
        -webkit-border-bottom-left-radius: $mds-border-radius-panel;
      }

      tr:last-child td:last-child {
        border-bottom-right-radius: $mds-border-radius-panel;
        -moz-border-bottom-right-radius: $mds-border-radius-panel;
        -webkit-border-bottom-right-radius: $mds-border-radius-panel;
      }
    }
  }
  .mds-data-table__header {
    background-color: #12698d;
    color: $mds-color-white;
  }
  .mds-data-table__body .mds-data-table__cell,
  .mds-data-table__header .mds-data-table__header-cell {
    padding-top: $mds-space-inset-1-x;
    padding-bottom: $mds-space-inset-1-x;
    padding-left: $mds-space-inset-2-x;
    padding-right: $mds-space-inset-2-x;
  }
  .mds-data-table__body .mds-data-table__cell:first-child {
    background-color: $mds-color-neutral-90;
  }
}
</style>
